(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  class DetailsPhotoRail extends HTMLElement {
    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.details-photo-rail__image'));
      this.thumbs = Array.from(this.querySelectorAll('.details-photo-rail__thumb'));
      this.prevButton = this.querySelector('.details-photo-rail__arrow--prev');
      this.nextButton = this.querySelector('.details-photo-rail__arrow--next');
      this.activeIndex = 0;

      this.show(0);

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.move(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(parseInt(thumb.dataset.index, 10)));
      });
    }

    move(delta) {
      const count = this.images.length;
      if (!count) return;
      this.show((this.activeIndex + delta + count) % count);
    }

    show(index) {
      if (!this.images.length) return;
      this.activeIndex = index;
      this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('details-photo-rail')) {
    customElements.define('details-photo-rail', DetailsPhotoRail);
  }

  } catch(e) { console.error(e); }
})();
})();
